import classNames from "classnames";
import styles from "./retractable.module.css";

export const Retractable = ({ className, active, children, ...props }) => {
    return (
        <div className={classNames(className, styles.retractable, {[styles.active]: active})} {...props}>
            <div className={styles.retractable_container}>
                {children}
            </div>
        </div>
    );
}